import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from "react-router-dom";
import {Provider, useDispatch} from 'react-redux';
import reduxStore from "./redux/ReduxStore";
import Axios from "axios";
import { storeConfig } from './redux/Reducer';
import {Spin} from "antd";

const Main = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = React.useState(true);

    const fetchConfig = async () => {
        const link = window.origin + '/env';
        try {
            const res = await Axios.get(link);
            if (res.data) {
                console.log("Config fetched", res.data);
                dispatch(storeConfig(res.data));
                setIsLoading(false);
                return res.data;
            }
        } catch (error) {
            console.log("Error in Config", error);
            return null;
        }
    };

    const setConfig = async () => {
        try {
            setIsLoading(true);
            const configToUse = await fetchConfig();
            console.log("Config fetched successfully");
        } catch (error) {
            console.log("Error setting config", error);
        }
    };

    useEffect(() => {
        setConfig();
    }, [dispatch]);

    return isLoading? <div style={{ height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}><Spin size="large" /></div> : <App />;
}

ReactDOM.render(
    <BrowserRouter>
        <Provider store={reduxStore}>
            <Main />
        </Provider>
    </BrowserRouter>
    ,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
